Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'sort-alpha-down';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f15d';
var svgPathData = 'M447.17 202.94l-61.05-160A16 16 0 0 0 371 32h-38a15.92 15.92 0 0 0-15.1 10.94l-61.06 160a16 16 0 0 0 15.1 21.06h16.78a15.93 15.93 0 0 0 15.11-10.94L314.35 184h75.3l10.52 29.06A15.93 15.93 0 0 0 415.28 224h16.78a16 16 0 0 0 15.11-21.06zM331.73 136L352 80l20.27 56zM416 288H288a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h77.11L281 422.69a32 32 0 0 0-9 22.31v19a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-77.11L423 345.29a32 32 0 0 0 9-22.29v-19a16 16 0 0 0-16-16zm-252 96h-44V48a16 16 0 0 0-16-16H88a16 16 0 0 0-16 16v336H28a12 12 0 0 0-8.73 20.24l68 72a12 12 0 0 0 17.44 0l68-72A12 12 0 0 0 164 384z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]
};

exports.farSortAlphaDown = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;